<template>
  <section id="home" class="hero fade-in">
    <div class="hero-content">
      <h1>Scrub Point</h1>
      <p>{{ $t('home.subtitle') }}</p>
      <a  href="mailto:sales@scrub-point.com" class="cta-button" @click.prevent="$emit('scrollTo', 'contact')">
        {{ $t('contact.title') }}
      </a>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeSection' };
</script>

<style scoped>
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  background: linear-gradient(135deg, #00c4fc, #0f172a);
  color: white;
  text-align: center;
}
.hero-content {
  animation: fadeIn 1s ease-in-out;
}
.cta-button {
  display: inline-block;
  background: white;
  color: #0f172a;
  padding: 0.7rem 1.5rem;
  border-radius: 25px;
  margin-top: 1.5rem;
  font-weight: bold;
  transition: background 0.3s;
}
.cta-button:hover {
  background: #f0f0f0;
}
.fade-in {
  animation: fadeIn 1.5s ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
